import * as React from "react";
import { Icon } from "@iconify/react";
import { useState, useEffect } from "react";
import copyOutline from "@iconify/icons-eva/copy-outline";
import plusFill from "@iconify/icons-eva/plus-fill";
import Box from "@mui/material/Box";
import { Link as RouterLink, useNavigate, useHistory } from "react-router-dom";
import copy from "copy-to-clipboard";
import Modal from "@mui/material/Modal";
import styled from "styled-components";
import { compactAddress } from "../contractData/function";
import { toaster } from "../utils/toast";
import ArrowDownFill from "@iconify/icons-eva/arrow-down-fill";
import Collapse from "@kunukn/react-collapse";
import HexagonLoader from "../assets/raiser_loader.gif";
import { web3 } from "../web3";

import {
  Card,
  Table,
  Stack,
  Button,
  TableRow,
  TableBody,
  TableCell,
  Container,
  Typography,
  TableContainer,
  TablePagination,
} from "@mui/material";

import Page from "../components/Page";
import Scrollbar from "../components/Scrollbar";
import SearchNotFound from "../components/SearchNotFound";
import { UserListHead, UserMoreMenu } from "../components/_dashboard/user";
import USERLIST from "../_mocks_/user";
import MetamaskImg from "../assets/mm.png";
import { services } from "../services";
import moment from "moment";
import { TimeStampToDateString } from "src/contractData/function";
import axios from "axios";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  borderRadius: "30px",
  boxShadow: 24,
  p: 4,
};

const TABLE_HEAD = [
  { id: "srNo", label: "Sr No", alignRight: false },
  { id: "igoName", label: "IDOName", alignRight: false },
  { id: "igoTokenName", label: "IDOToken Address", alignRight: false },
  { id: "network", label: "Network", alignRight: false },
  {
    id: "tokenDistributionDate",
    label: "Distribution Date",
    alignRight: false,
  },
  { id: "poolStatus", label: "PoolStatus", alignRight: false },
  { id: "OwnerAddress", label: "Owner", alignRight: false },
  { id: "igoTokenSymbol", label: "Symbol", alignRight: false },
  { id: "disable", label: "Disable", alignRight: false },
  { id: "actions", label: "Actions", alignRight: false },
];

export default function User() {
  const navigate = useNavigate();
  const [page, setPage] = useState(0);
  const [totalPage, setTotalPage] = useState("");
  const [totalRecords, setTotalRecords] = useState("");
  const [totalActivePool, setTotalActivePool] = useState("");
  const [totalCompletePool, setTotalCompletePool] = useState("");
  const [order, setOrder] = useState("asc");
  const [orderBy, setOrderBy] = useState("name");
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [claim, setClaim] = useState([]);
  const [pendingData, setPendingData] = useState([]);
  const [isDeployedPools, setIsDeployedPools] = useState(false);
  const [deployedPools, setDeployedPools] = useState([]);
  const [completeIgo, setCompleteIgo] = useState([]);
  const [allPoolsData, setAllPoolsData] = useState([]); // Store all pools data
  const [selectedBtn, setSelectedBtn] = useState("alreadyUpdated");
  const [web3Data, setWeb3Data] = useState({
    isLoggedIn: false,
    accounts: [],
  });

  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const [selectedDropdownBtn, setSelectedDropdownBtn] = useState("ALL");
  const [filteredData, setFilteredData] = useState([]);
  const [reload, setReload] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    // Fetch data based on current filter when page changes
    if (selectedDropdownBtn !== "ALL") {
      fetchFilteredData(selectedDropdownBtn, newPage + 1);
    }
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  // Check metamask connected or not
  const checkIsConnected = () => {
    web3.eth.getAccounts(function (err, accounts) {
      if (err || accounts.length === 0) {
        setWeb3Data({
          isLoggedIn: false,
          accounts: [],
        });
      } else {
        setWeb3Data({
          isLoggedIn: true,
          accounts: accounts,
        });
      }
    });
  };

  // Connect metamask
  const connectMetamask = async () => {
    try {
      const getAcountDetails = await services.enableMetamask();
      setWeb3Data(getAcountDetails);
      if (getAcountDetails.isLoggedIn) {
        navigate("/dashboard/addclaimpools");
      }
    } catch (err) {
      console.log("error is:", err);
    }
  };

  const navigateToPage = (route) => {
    console.log("route is:", route);
    navigate(route, { replace: true });
  };

  // Fetch all IGO data (for ALL filter)
  const fetchAllIgo = async (page) => {
    setLoading(true);
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_DEV_API}/IGOPools/listAllIGO?page=${page}`
      );
      
      if (response.status === 200) {
        setAllPoolsData(response.data.data);
        setFilteredData(response.data.data);
        setTotalPage(response.data.pagination.totalRecords);
        setTotalRecords(response.data.pagination.totalRecords);
      }
    } catch (error) {
      console.error("Error fetching all IGO data:", error);
    } finally {
      setLoading(false);
    }
  };

  // Fetch filtered data based on pool status
  const fetchFilteredData = async (filterType, pageNumber = 1) => {
    setLoading(true);
    try {
      let url = "";
      
      switch (filterType) {
        case "upcoming":
          url = `${process.env.REACT_APP_DEV_API}/IGOPools/upcoming-list?page=${pageNumber}`;
          break;
        case "featured":
          url = `${process.env.REACT_APP_DEV_API}/IGOPools/featured-list?page=${pageNumber}`;
          break;
        case "completed":
          url = `${process.env.REACT_APP_DEV_API}/IGOPools/completed-list?page=${pageNumber}`;
          break;
        default:
          return;
      }

      const response = await axios.get(url);
      
      if (response.status === 200) {
        setFilteredData(response.data.data);
        
        // Set appropriate total count based on filter type
        if (filterType === "upcoming") {
          setTotalPage(response.data.pagination.totalCount);
        } else if (filterType === "featured") {
          setTotalActivePool(response.data.pagination.totalCount);
        } else if (filterType === "completed") {
          setTotalCompletePool(response.data.pagination.totalCount);
        }
      }
    } catch (error) {
      console.error(`Error fetching ${filterType} data:`, error);
    } finally {
      setLoading(false);
    }
  };

  // Initial data fetch for individual pools (for counts and basic data)
  const fetchInitialData = async () => {
    try {
      let competedUrl = axios.get(
        `${process.env.REACT_APP_DEV_API}/IGOPools/completed-list?page=1`
      );
      let featuredUrl = axios.get(
        `${process.env.REACT_APP_DEV_API}/IGOPools/featured-list?page=1`
      );
      let upcomingUrl = axios.get(
        `${process.env.REACT_APP_DEV_API}/IGOPools/upcoming-list?page=1`
      );

      Promise.all([competedUrl, featuredUrl, upcomingUrl]).then(([res1, res2, res3]) => {
        setCompleteIgo(res1.data.data);
        setTotalCompletePool(res1.data.pagination.totalCount);
        setTotalActivePool(res2.data.pagination.totalCount);
        setPendingData(res2.data.data);
        setTotalPage(res3.data.pagination.totalCount);
        setDeployedPools(res3.data.data);
      });
    } catch (error) {
      console.error("Error fetching initial data:", error);
    }
  };

  useEffect(() => {
    fetchInitialData();
    // Load all data by default
    fetchAllIgo(page + 1);
  }, []);

  // Handle page changes for ALL filter
  useEffect(() => {
    if (selectedDropdownBtn === "ALL") {
      fetchAllIgo(page + 1);
    }
  }, [page, selectedDropdownBtn]);

  const isActive = (btn) => {
    if (btn === selectedBtn) return "active";
  };

  const isToggleClick = (checked, _id) => {
    dumpAction(!checked, _id);
  };

  const dumpAction = async (status, _id) => {
    const url = `${process.env.REACT_APP_DEV_API}/IGOPools/igo-edit`;
    const payload = { _id: _id, isDisabledBit: status };
    const sendRequest = await axios.post(url, payload);
    if (sendRequest.status === 200) {
      return toaster(`${"Pool Status Updated Successfully"}`, "success");
    }
  };

  const copyToClipboard = (address) => {
    copy(address);
    return toaster(`${"Copied!"}`, "success");
  };

  const [isOpen1, setIsOpen1] = React.useState(false);

  const onInit = () => {
    setIsOpen1(false);
  };

  const applyFilter = (type) => {
    setPage(0); // Reset to first page when applying filter
    setSelectedDropdownBtn(type);
    onInit();
    
    if (type === "ALL") {
      // For ALL, fetch from listAllIGO endpoint
      fetchAllIgo(1);
    } else {
      // For specific filters, fetch filtered data with pagination
      fetchFilteredData(type, 1);
    }
  };

  // Get total count based on selected filter
  const getTotalCount = () => {
    switch (selectedDropdownBtn) {
      case "upcoming":
        return parseInt(totalPage);
      case "featured":
        return parseInt(totalActivePool);
      case "completed":
        return parseInt(totalCompletePool);
      case "ALL":
      default:
        return parseInt(totalRecords); // Assuming totalPage holds count for ALL
    }
  };

  return (
    <Page title="Manage Claims | Raiser Snapshot">
      <Container>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          mb={5}
        >
          <Typography variant="h4" gutterBottom>
            IDO Pools
          </Typography>
          <ButtonList>
            <Button
              className={isActive("alreadyUpdated")}
              variant="contained"
              to=""
              onClick={() => {
                setSelectedBtn("alreadyUpdated");
                setIsOpen1((state) => !state);
              }}
              style={{ color: "#000000" }}
            >
              {selectedDropdownBtn}
              <Icon
                icon={ArrowDownFill}
                width={18}
                height={18}
                onClick={() => setIsOpen1((state) => !state)}
              />
            </Button>
            <CompletedBox>
              <Collapse onInit={() => onInit()} isOpen={isOpen1}>
                <ul>
                  <li onClick={() => applyFilter("ALL")} style={{backgroundColor: '#151517'}}>
                    ALL
                  </li>
                  <li onClick={() => applyFilter("upcoming")} style={{backgroundColor: '#151517'}}>
                    Upcoming
                  </li>
                  <li onClick={() => applyFilter("featured")} style={{backgroundColor: '#151517'}}>
                    Featured
                  </li>
                  <li onClick={() => applyFilter("completed")} style={{backgroundColor: '#151517'}}>
                    Completed
                  </li>
                </ul>
              </Collapse>
            </CompletedBox>
            <Button
              variant="contained"
              to=""
              onClick={() => {
                navigateToPage("/dashboard/addIgo");
              }}
              startIcon={<Icon icon={plusFill} />}
              sx={{ background: "linear-gradient(267.83deg, #FBAE48 6.21%, #F05C87 107.97%)" }}
              style={{ color: "#000000" }}
            >
              Add IDO
            </Button>
          </ButtonList>
        </Stack>
        
        <Modal
          open={open}
          onClose={handleClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={style}>
            <Typography id="modal-modal-description" sx={{ mt: 2 }}>
              <h3 style={{ textAlign: "center" }}>
                Please connect to your Wallet
              </h3>
              <MetamaskBTN
                onClick={() => {
                  connectMetamask();
                }}
              >
                <img src={MetamaskImg} alt="" /> Connect Metamask
              </MetamaskBTN>
            </Typography>
          </Box>
        </Modal>
        
        <Card style={{backgroundColor: '#151517'}}>
          <Scrollbar>
            <TableContainer sx={{ minWidth: 800 }}>
              <Table>
                <UserListHead
                  order={order}
                  orderBy={orderBy}
                  headLabel={TABLE_HEAD}
                  rowCount={USERLIST.length}
                  onRequestSort={handleRequestSort}
                />
                <TableBody>
                  {!loading && filteredData.map((row, index) => {
                    const {
                      _id,
                      igoName,
                      igoTokenName,
                      network,
                      tokenDistributionDate,
                      poolStatus,
                      ownerAddress,
                      igoTokenSymbol,
                      isDisabledBit,
                    } = row;
                    return (
                      <TableRow hover key={_id} tabIndex={-1}>
                        <TableCell
                          style={{ padding: "14px", whiteSpace: "nowrap" }}
                          spacing={2}
                        >
                          {page * rowsPerPage + index + 1}
                        </TableCell>
                        <TableCell component="th" scope="row" padding="none">
                          {igoName}
                        </TableCell>
                        <TableCell
                          align="left"
                          style={{ padding: "14px", whiteSpace: "nowrap" }}
                        >
                          {compactAddress(igoTokenName)}
                          <span
                            style={{
                              position: "relative",
                              top: "4px",
                              cursor: "pointer",
                            }}
                          >
                            <Icon
                              icon={copyOutline}
                              onClick={() => copyToClipboard(igoTokenName)}
                              height={18}
                              width={18}
                            />
                          </span>
                        </TableCell>
                        <TableCell
                          style={{ padding: "14px", whiteSpace: "nowrap" }}
                          align="left"
                        >
                          {network}
                        </TableCell>
                        <TableCell
                          style={{ padding: "14px", whiteSpace: "nowrap" }}
                          align="left"
                        >
                          {TimeStampToDateString(tokenDistributionDate)}
                        </TableCell>
                        <TableCell
                          style={{ padding: "14px", whiteSpace: "nowrap" }}
                          align="left"
                        >
                          {poolStatus}
                        </TableCell>
                        <TableCell
                          align="left"
                          style={{ padding: "14px", whiteSpace: "nowrap" }}
                        >
                          {compactAddress(ownerAddress)}
                          <span
                            style={{
                              position: "relative",
                              top: "4px",
                              cursor: "pointer",
                            }}
                          >
                            <Icon
                              icon={copyOutline}
                              onClick={() => copyToClipboard(ownerAddress)}
                              height={18}
                              width={18}
                            />
                          </span>
                        </TableCell>
                        <TableCell
                          style={{ padding: "14px", whiteSpace: "nowrap" }}
                          align="left"
                        >
                          {igoTokenSymbol}
                        </TableCell>
                        {selectedBtn === "alreadyUpdated" && (
                          <TableCell
                            align="center"
                            style={{ padding: "14px", whiteSpace: "nowrap" }}
                          >
                            <CustomSwitch>
                              <label className="switch">
                                <input
                                  type="checkbox"
                                  value={_id}
                                  defaultChecked={!isDisabledBit}
                                  onChange={(e) =>
                                    isToggleClick(
                                      e.target.checked,
                                      e.target.value
                                    )
                                  }
                                />
                                <span className="slider round"></span>
                              </label>
                            </CustomSwitch>
                          </TableCell>
                        )}
                        <TableCell
                          align="right"
                          style={{ padding: "14px", whiteSpace: "nowrap" }}
                        >
                          <UserMoreMenu
                            menu="claimPool"
                            id={_id}
                            url={
                              selectedBtn === "pending"
                                ? `/dashboard/editIgoPool/${_id}`
                                : `/dashboard/editIgoPool/${_id}`
                            }
                          />
                        </TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
                {(loading || filteredData.length === 0) && (
                  <TableBody>
                    <TableRow>
                      <TableCell align="center" colSpan={10} sx={{ py: 3 }}>
                        {loading ? (
                          <LoaderOuter>
                            <div className="loader">
                              <img className="loader-img" src={HexagonLoader} alt="" />
                            </div>
                          </LoaderOuter>
                        ) : (
                          <SearchNotFound style={{backgroundColor: '#151517', color: '#FBAE48'}} />
                        )}
                      </TableCell>
                    </TableRow>
                  </TableBody>
                )}
              </Table>
            </TableContainer>
          </Scrollbar>

          <TablePagination
            rowsPerPageOptions={[10]}
            component="div"
            count={getTotalCount()}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Card>
      </Container>
    </Page>
  );
}

// Styled components remain the same
const CustomSwitch = styled.div`
  .switch {
    position: relative;
    display: inline-block;
    width: 40px;
    height: 23px;
  }

  .switch input {
    opacity: 0;
    width: 0;
    height: 0;
  }

  .slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #ccc;
    -webkit-transition: 0.4s;
    transition: 0.4s;
  }

  .slider:before {
    position: absolute;
    content: "";
    height: 16px;
    width: 16px;
    left: 4px;
    bottom: 4px;
    background-color: white;
    -webkit-transition: 0.4s;
    transition: 0.4s;
  }

  input:checked + .slider {
    background: linear-gradient(267.83deg, #FBAE48 6.21%, #F05C87 107.97%);
    border-radius: 10px;
  }

  input:focus + .slider {
    box-shadow: 0 0 1px #FBAE48;
  }

  input:checked + .slider:before {
    -webkit-transform: translateX(16px);
    -ms-transform: translateX(16px);
    transform: translateX(16px);
  }

  .slider.round {
    border-radius: 34px;
  }

  .slider.round:before {
    border-radius: 50%;
  }
`;

const LoaderOuter = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  .loader {
    width: 45px;
    height: 45px;
    margin: 20px auto;
  }
`;

const ButtonList = styled.div`
  display: flex;
  align-items: center;
  Button {
    margin: 0px 5px;
    &.active {
      background: #F05C87;
      border-radius: 10px;
    }
  }
`;

const MetamaskBTN = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 20px auto;
  padding: 10px 30px;
  border-radius: 10px;
  border: none;
  font-size: 20px;
  font-weight: bold;
  color: #000;
  cursor: pointer;
  img {
    width: 45px;
    margin-right: 10px;
  }
`;

const CompletedBox = styled.div`
  position: relative;
  .collapse-css-transition {
    position: absolute;
    top: 22px;
    right: 0px;
    left: auto;
    z-index: 9;
    width: 200px;
    transition: height 252ms cubic-bezier(0.4, 0, 0.2, 1);
    background-color: #fff;
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.25);
    border-radius: 5px;
  }
  li {
    padding: 10px;
    cursor: pointer;
  }
`;